import store from "../";
import Api from "../../api.service";
import Swal from "sweetalert2";
const state = {
    subsList:[],
    subsTypes:[],
    filterSubscribeList: [],
    subsForm:{
        id:null,
        shopId:null,
        subsType:null,
        subscribeDates:[],
        subscribeStartDate:"",
        subscribeEndDate:"",
        notiSubsCount:"",
        notiSubsStart:"",
        notiSubsEnd:"",
        imgSubsStart: "",
        imgSubsCount: null,
        imgSubsCountUsed: null,

        imgSubsEnd: "",
        offerSubsCount: null,
        offerSubsCountUsed:null,

        offerSubsStart:"",
        offerSubsEnd:""
    },
    subsFilterForm:{
        subsType: -1,
        subscribeDates:[],
        outDated:false
    },
    subsExtenedForm: {
        subsType: -1,
        subscribeDates: [],
        days: 0
    }
};
const getters = {
    subsList(state)
    {
        return state.subsList;
    },
    subsTypes(state)
    {
        return state.subsTypes;
    },
    subsForm(state)
    {
        return state.subsForm;
    },
    subsFilterForm(state)
    {
        return state.subsFilterForm;
    },
    subsExtenedForm(state) {
        return state.subsExtenedForm;
    },
    filterSubscribeList(state) {
        return state.filterSubscribeList;
    }
};
const mutations = {
    GET_SUBS_ITEMS(state,payload){
        state.subsList = payload.subscriptions;
        state.subsTypes = payload.subscriptionTypes;
        state.filterSubscribeList = payload.subscriptions;
        store.dispatch('setLoading', false);
    },
    GET_SUBS_FORM(state,payload)
    {
        Object.assign(state.subsForm, state.subsList[payload]);
    },
    SET_SUBS_ITEM(state,payload)
    {
        const index = state.subsList.findIndex(item=> item.shopId == payload.shopId);
        Object.assign(state.subsList[index], payload);
    },
    EXTEND_SUBSCRIPTION(state) {
        Swal.fire({
            title: "تم التمديد !",
            text: `تم التمديد بنجاح`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    REMOVE_SUBSCRIPTION(state,payload)
    {
        const index = state.subsList.findIndex(item=> item.shopId == payload.shopId);
        Object.assign(state.subsList[index], payload);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف الاشتراك بنجاح`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    FILTER_IT_SUBSCRIPTION(state, payload){
        state.filterSubscribeList = state.subsList.filter((subsItem) => {
            let dateMainSubsEnd         = subsItem.subscribeEndDate;
            let mainSubsState           = subsItem.mainSubsState;

            let dateNotiSubsEnd         = subsItem.notiSubsEnd;
            let notiSubsState           = subsItem.notiSubsState;

            let dateImgSubsEnd          = subsItem.imgSubsEnd;
            let imgSubsState            = subsItem.imgSubsState;


            let dateOfferSubsEnd        = subsItem.offerSubsEnd;
            let offerSubsState          = subsItem.offerSubsState;
            switch(state.subsFilterForm.subsType) {
                case 0: {
                    return (
                            (!state.subsFilterForm.outDated || mainSubsState == 3) &&
                            (
                                (
                                    new Date(state.subsFilterForm.subscribeDates[0]).getTime() <= new Date(dateMainSubsEnd).getTime() &&
                                    new Date(state.subsFilterForm.subscribeDates[1]).getTime() >= new Date(dateMainSubsEnd).getTime()
                                )   || !state.subsFilterForm.subscribeDates.length
                            )
                        )
                }
                case 1: {
                    return (
                        (!state.subsFilterForm.outDated || notiSubsState == 3) &&
                        (
                            (
                                new Date(state.subsFilterForm.subscribeDates[0]).getTime() <= new Date(dateNotiSubsEnd).getTime() &&
                                new Date(state.subsFilterForm.subscribeDates[1]).getTime() >= new Date(dateNotiSubsEnd).getTime()
                            )   || !state.subsFilterForm.subscribeDates.length
                        )
                    )
                }
                case 2: {
                    return (
                        (!state.subsFilterForm.outDated || imgSubsState == 3) &&
                        (
                            (
                                new Date(state.subsFilterForm.subscribeDates[0]).getTime() <= new Date(dateImgSubsEnd).getTime() &&
                                new Date(state.subsFilterForm.subscribeDates[1]).getTime() >= new Date(dateImgSubsEnd).getTime()
                            )   || !state.subsFilterForm.subscribeDates.length
                        )
                    )
                }
                case 3: {
                    return (
                        (!state.subsFilterForm.outDated || offerSubsState == 3) &&
                        (
                            (
                                new Date(state.subsFilterForm.subscribeDates[0]).getTime() <= new Date(dateOfferSubsEnd).getTime() &&
                                new Date(state.subsFilterForm.subscribeDates[1]).getTime() >= new Date(dateOfferSubsEnd).getTime()
                            )   || !state.subsFilterForm.subscribeDates.length
                        )
                    )
                }
                default: return true;
            }
        });
    },
    RESET_FILTER_SUBSCRIPTION(state) {
        state.filterSubscribeList = state.subsList;
        Object.assign(state.subsFilterForm, {
            subsType: -1,
            subscribeDates: [],
            outDated: false
        });
    }
};
const actions = {
    async fetchSubscriptions(context, payload) {
        const { data } = await Api.query("/api/Subscription/GetSubscriptions")
            .then((data) => data);
        
        context.commit("GET_SUBS_ITEMS", data);
    },
    async fetchSubsForm(context,payload)
    {
        context.commit("GET_SUBS_FORM", payload);
    },
    async SetSubscription(context,payload)
    {
        const { data } = await Api.post("/api/Subscription/SetSubscription",{
            ShopId: payload.shopId,
            SubscriptionType: payload.subsType,
            SubscribeStartDate: payload.subscribeDates[0],
            SubscribeEndDate: payload.subscribeDates[1],
            NotificationCount: payload.notiSubsCount,
            ImgSubsCount: payload.imgSubsCount,
            OfferSubsCount: payload.offerSubsCount


        }).then((data)=> data);

        context.commit("SET_SUBS_ITEM",data);
    },
    async ExtendSubscription(context, payload) {
        const { data } = await Api.post("/api/Subscription/ExtendSubscription", {
            SubscriptionType: payload.subsType,
            SubscribeStartDate: payload.subscribeDates[0],
            SubscribeEndDate: payload.subscribeDates[1],
            DaysCount: parseInt(payload.days)

        }).then((data) => data);

        context.commit("EXTEND_SUBSCRIPTION");
    },
    async RemoveSubscription(context,payload)
    {
        const item = state.subsList[payload.index];
        const {data} = await Api.delete(`/api/Subscription/RemoveSubscription?shopId=${item.shopId}&subsType=${payload.type}`)
            .then((data) => data);
        context.commit("REMOVE_SUBSCRIPTION", data);
    },
    filterItSubscription(context){
        context.commit('FILTER_IT_SUBSCRIPTION');
    },
    resetFilter(context) {
        context.commit('RESET_FILTER_SUBSCRIPTION');
    }
};

const subscription = { state, getters, mutations, actions }
export default subscription;